// // contexts/AuthContext.js
// import { createContext } from 'react';

// // Helper function to transform API user data to match frontend needs
// export const transformUserData = (apiUser) => {
//     return {
//         id: apiUser.id,
//         username: apiUser.username,
//         email: apiUser.email,
//         phone_number: apiUser.phone_number,
//         first_name: apiUser.first_name,
//         last_name: apiUser.last_name,
//         full_name: `${apiUser.first_name} ${apiUser.last_name}`.trim(),
//         role: apiUser.role,
//         is_active: apiUser.is_active,
//         date_joined: apiUser.date_joined,
//         updated_at: apiUser.updated_at,
//         agent_profile: apiUser.agent_profile,
//     };
// };

// // Create context with undefined default
// export const AuthContext = createContext(undefined);









// contexts/AuthContext.js
import { createContext } from 'react';

// Helper function to transform API user data to match frontend needs
export const transformUserData = (apiUser) => {
    // New derived flags for the registration-fee gate
    const isAgentLike = apiUser.role === 'AGENT' || apiUser.role === 'SUB_AGENT';
    const registrationFeePaid =
        apiUser.agent_profile?.registration_fee_paid ?? true;
    const isUnpaidAgent = isAgentLike && registrationFeePaid === false;

    return {
        id: apiUser.id,
        username: apiUser.username,
        email: apiUser.email,
        phone_number: apiUser.phone_number,
        first_name: apiUser.first_name,
        last_name: apiUser.last_name,
        full_name: `${apiUser.first_name} ${apiUser.last_name}`.trim(),
        role: apiUser.role,
        is_active: apiUser.is_active,
        date_joined: apiUser.date_joined,
        updated_at: apiUser.updated_at,
        agent_profile: apiUser.agent_profile,

        // Derived — used by the banner, sidebar gating, and route guards
        is_unpaid_agent: isUnpaidAgent,
        is_fully_registered_agent: isAgentLike && registrationFeePaid === true,
    };
};

// Create context with undefined default
export const AuthContext = createContext(undefined);